import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BuyCoinModal from "./Modal/BuyCoinModal";
import SellCoinModal from "./Modal/SellCoinModal";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import HTMLReactParser from "html-react-parser";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";
import MobileNewCoinCandle from "./MobileNewCoinCandle";
const LiveCoinDetails = () => {
    const { authUser } = useContext(AuthContext);
    const { id } = useParams();

    const [userData, setUserData] = useState([]);
    const [updateData, setUpdateData] = useState([]);

    useEffect(() => {
        if (authUser?._id) {
            fetch(`https://api.wlfmobile.com/api/user/auth/view/${authUser?._id}`, {
                method: "GET",
            })
                .then((res) => res.json())
                .then((data) => {
                    setUserData(data.data);
                });
        }
    }, [authUser?._id, updateData]);

    const [userNewCoinHistory, setUserNewCoinHistory] = useState([]);

    useEffect(() => {
        if (authUser?._id) {
            fetch(
                `https://api.wlfmobile.com/api/user/new/coin/buy/history/single/view/${authUser?._id}/${id}`,
                {
                    method: "GET",
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    setUserNewCoinHistory(data?.data);
                });
        }
    }, [authUser?._id, updateData]);

    // useEffect(() => {
    //   if (authUser?._id) {
    //     fetch(
    //       `https://api.wlfmobile.com/api/user/new/coin/buy/history/view/${authUser?._id}`,
    //       {
    //         method: "GET",
    //       }
    //     )
    //       .then((res) => res.json())
    //       .then((data) => {
    //         setUserNewCoinHistory(data);
    //       });
    //   }
    // }, [authUser?._id, updateData]);

    const [coinData, setCoinData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`https://api.wlfmobile.com/api/user/new/coin/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setCoinData(data.data);
                setLoading(false);
            });
    }, [updateData]);

    //   const [livePrice, setLivePrice] = useState([]);

    //   useEffect(() => {
    //     const interval = setInterval(() => {
    //       fetchData();
    //     }, 1000);
    //     return () => clearInterval(interval);
    //   }, [livePrice, coinData]);

    //   const fetchData = async () => {
    //     if (coinData?.symbol) {
    //       fetch(
    //         `https://api.wlfmobile.com/api/user/new/coin/price/view/${coinData?._id}`,
    //         {
    //           method: "GET",
    //         }
    //       )
    //         .then((res) => res.json())
    //         .then((data) => {
    //           setLivePrice(data.data);
    //           if (data.data) {
    //             setLivePrice(data?.data);
    //           }
    //         });
    //     }
    //   };









    ////////////////////////////////////////////


    var newSeries = useRef(null);
    const isCandleDataLoading = useRef(true);
    const [chartReady, setChartReady] = useState(false);
    const [candleData, setCandleData] = useState([]);

    const [currentTimeFrame, updateTimeFrame] = useState({
        period: "1m",
        limit: 1000,
        activeclass: "1m",
    });

    const PeriodChangeFun = (data) => {
        isCandleDataLoading.current = true;
        updateTimeFrame(data);
    }



    useEffect(() => {
        fetch(`https://new-coin-api.wlfmobile.com/api/user/new/coin/price/view/${id}?period=${currentTimeFrame?.period}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data)
                // setCandleData(data?.data);
                const resultsData = data?.data || [];
                // const sortData = resultsData.sort((a, b) => (a.time > b.time ? 1 : -1));
                const sortData = [...resultsData].sort((a, b) => (a.time > b.time ? 1 : -1));
                const candles = sortData.map(d => ({
                    time: d.time / 1000,
                    open: d.open,
                    high: d.high,
                    low: d.low,
                    close: d.close,
                }));
                setCandleData(candles);

            });
    }, [currentTimeFrame?.period, id]);



    useEffect(() => {

        if (!chartReady) return;
        if (!candleData.length) return;

        newSeries.current?.setData(candleData);
        isCandleDataLoading.current = false;

    }, [chartReady, candleData]);

    //   console.log(data[data.length-1]);
    //   console.log(parseInt(data[data.length-1]?.time));

    const [liveData, setLiveData] = useState([]);


    useEffect(() => {
        const interval = setInterval(() => {
            fetch(
                `https://new-coin-api.wlfmobile.com/api/user/new/coin/price/live/view/${id}?period=${currentTimeFrame?.period}`
            )
                .then(res => res.json())
                .then(data => {
                    const liveData = data?.data;

                    if (!liveData) return;

                    setLiveData(liveData);
                    const editLiveData = {
                        time: liveData?.time / 1000,
                        open: liveData.open,
                        high: liveData.high,
                        low: liveData.low,
                        close: liveData.close,
                    };
                // console.log(liveData.time)
                // console.log(liveData.open)

                    if (newSeries.current && editLiveData.time && !isCandleDataLoading.current && chartReady) {
                        newSeries.current.update(editLiveData);
                    }
                });
        }, 1000);

        return () => clearInterval(interval);
    }, [currentTimeFrame.period, id, chartReady]);




    ///////////////////////////////////////////////

    //   modal

    const [BuyModalShow, setBuyModalShow] = useState(false);
    const [SellModalShow, setSellModalShow] = useState(false);

    if (loading) {
        return <></>;
    }
    return (
        <>
            <section className=" mobile-trade-section user-dashboard new-coin-details-area">
                <div className="row">
                    <div className="col-12">
                        <div className="trade-area-posce">
                            <div className="charts ">
                                <div
                                    className="charts__head"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasLeft"
                                    aria-controls="offcanvasLeft"
                                >
                                    <div className="d-flex gap-3">
                                        <Link
                                            className="nav__link js-tabs-link active"
                                            style={{ color: "lime" }}
                                            to="/user/new/coin/buy/history"
                                        >
                                            Total Coin: {userNewCoinHistory?.coin_amount ? parseFloat(userNewCoinHistory?.coin_amount).toFixed(2) : 0.00}
                                        </Link>
                                    </div>

                                    {liveData?.close && (
                                        <div className="nav">
                                            <button
                                                className="nav__link js-tabs-link active"
                                                style={{ color: "lime" }}
                                            >
                                                {liveData?.close}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p className="btn btn-primary expired_time-css pb-2 mt-3">
                                <FlipClockCountdown
                                    to={coinData?.expired_time}
                                    className="flip-clock"
                                ></FlipClockCountdown>
                            </p>
                            <MobileNewCoinCandle data={{ newSeries, liveData, currentTimeFrame, PeriodChangeFun, setChartReady }} />


                            <div className="new-coin-details py-5">
                                <img
                                    className="new-coin-logo"
                                    src={`https://api.wlfmobile.com/${coinData?.image}`}
                                    alt=""
                                />
                                <div>
                                    <div className="supply-coin">
                                        <p>Supply Coin :</p>
                                        <span>{coinData?.supply_coin}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex gap-3">
                                <button
                                    type="button"
                                    className="btn btn-success  w-100 "
                                    data-bs-toggle="modal"
                                    style={{ borderRadius: "30px" }}
                                    onClick={() => setBuyModalShow(true)}
                                >
                                    Subscribe
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-danger  w-100"
                                    data-bs-toggle="modal"
                                    style={{ borderRadius: "30px" }}
                                    onClick={() => setSellModalShow(true)}
                                >
                                    Sell
                                </button>
                            </div>

                            <div className="new-coin-dis">
                                <p> {coinData?.dis ? HTMLReactParser(coinData?.dis) : ""}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <BuyCoinModal
                className="mobile-trade-modal-section posce-trade-modal"
                BuyModalShow={BuyModalShow}
                setBuyModalShow={setBuyModalShow}
                livePrice={liveData}
                coinData={coinData}
                show={BuyModalShow}
                userData={userData}
                setUpdateData={setUpdateData}
                onHide={() => setBuyModalShow(false)}
            />
            <SellCoinModal
                className="mobile-trade-modal-section posce-trade-modal"
                SellModalShow={SellModalShow}
                setSellModalShow={setSellModalShow}
                livePrice={liveData}
                coinData={coinData}
                show={SellModalShow}
                userData={userData}
                setUpdateData={setUpdateData}
                onHide={() => setSellModalShow(false)}
            />
        </>
    );
};

export default LiveCoinDetails;
